  import {
    Card,
    Col,
    Form,
    Row,
    Input,
    InputNumber,
    Select,
    DatePicker,
  } from "antd";
  import dayjs from "dayjs";

  const { TextArea } = Input;

  const CustomerDetails = ({customerData}) => {

    // console.log("customerData++++++++++++",customerData);
    
    return (
      <>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="name"
              label="Customer Name"
              rules={[{ required: true, message: "Enter customer name" }]}
            >
              <Input size="large" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              name="mobile_no"
              label="Mobile No"
              rules={[{ required: true, message: "Enter mobile number" }]}
            >
              <InputNumber size="large" style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name="address" label="Address">
              <TextArea rows={2} size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          {/* <Col xs={24} sm={8}>
            <Form.Item name="eq_status" label="Enquiry Status">
              <Select
                size="large"
                showSearch
                allowClear
                placeholder="Select a status"
                options={optionStatus}
              />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} sm={8}>
            <Form.Item name="n_follow_up" label="Next Follow-up On">
              <DatePicker
                size="large"
                format="DD-MM-YYYY"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={8}>
            <Form.Item name="note" label="Note / Comment">
              <TextArea rows={2} size="large" />
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  };

  export default CustomerDetails;
